


// --- urlStateHelper.js ---

/*
This updates:
  zoom
  lat
  lng
*/


const DEFAULT_PORTAL_PARENT_ORIGINS = [
  'https://portal.fraemohs.co.nz',
  'http://localhost:5174',
  'http://127.0.0.1:5174'
];

const isAllowedPortalOrigin = (origin) => {
  try {
    const url = new URL(origin);

    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
      return true;
    }

    return url.protocol === 'https:' && (
      url.hostname === 'portal.fraemohs.co.nz' ||
      url.hostname.endsWith('.fraemohs.co.nz')
    );
  } catch {
    return false;
  }
};

const getPortalParentOrigins = () => {
  const origins = new Set(DEFAULT_PORTAL_PARENT_ORIGINS);

  if (document.referrer) {
    try {
      const referrerOrigin = new URL(document.referrer).origin;

      if (isAllowedPortalOrigin(referrerOrigin)) {
        origins.add(referrerOrigin);
      }
    } catch {
      // Ignore malformed referrers.
    }
  }

  return Array.from(origins);
};

export const publishCurrentUrlToParent = (url = window.location.href) => {
  if (window.parent === window) return;

  const href = url instanceof URL
    ? url.href
    : new URL(url, window.location.href).href;

  getPortalParentOrigins().forEach((origin) => {
    window.parent.postMessage({
      type: 'planhub:state',
      url: href
    }, origin);
  });
};

export const replaceUrlState = (url) => {
  window.history.replaceState({}, '', url);
  publishCurrentUrlToParent(url);
};

// Utility function to update multiple URL parameters
export const updateUrlParams = (paramsObj) => {

  const url = new URL(window.location);

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  });

  replaceUrlState(url);
};

// Utility function to get a single parameter from the URL
export const getUrlParam = (key) => {
  return new URLSearchParams(window.location.search).get(key);
};

